export default "__VITE_ASSET__YiPSqPDj__"